// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__11ka-","image":"Header_image__1864f","name":"Header_name__QUBwK","info":"Header_info__29dtR","infoRow":"Header_infoRow__2IdrG"};